module.exports = __webpack_public_path__ + "img/Logo.f9a91bad.png";